// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","258":"68ed61ce","455":"023cb25f","598":"9fc8505b","667":"85ad37a4","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};